import { Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { StudioPublicDto } from '../../../core/api/dtos';
import { injectTSDI } from '../../../core/common/tsdi';
import { StudioStore } from '../../../core/studio-store';

interface USAddressFormatProps {
    houseNumber?: string;
    street?: string;
    zip?: string;
    city?: string;
    provinceCode?: string;
}
export const USAddressFormat = ({
    houseNumber,
    street,
    city,
    provinceCode,
    zip
}: USAddressFormatProps) => {
    return (
        <>
            <Grid item xs={12}>
                <Typography>{`${houseNumber} ${street}`}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography>{`${city}, ${provinceCode} ${zip}`}</Typography>
            </Grid>
        </>
    );
};

export const StudioInformation = observer(
    ({ studioPublicDto }: { studioPublicDto?: StudioPublicDto }) => {
        const {
            street,
            houseNumber,
            zip,
            city,
            telephone,
            email,
            provinceCode
        } = studioPublicDto || {};
        const { studioCountry } = injectTSDI(StudioStore);

        return (
            <>
                <Grid item xs={12}>
                    <Typography data-role="contract-termination-studio-information-name">
                        {studioPublicDto?.name}
                    </Typography>
                </Grid>
                {studioCountry === 'US' ? (
                    <USAddressFormat
                        street={street}
                        houseNumber={houseNumber}
                        zip={zip}
                        provinceCode={provinceCode}
                        city={city}
                    />
                ) : (
                    <>
                        <Grid item xs={12}>
                            <Typography>
                                {`${street} ${houseNumber}`}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>{`${zip} ${city}`}</Typography>
                        </Grid>
                    </>
                )}
                <Grid item xs={12}>
                    <Typography>{telephone}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography>{email}</Typography>
                </Grid>
            </>
        );
    }
);
